import MainLayout from '@/layout/MainLayout';
import CenterLayout from '@/layout/centerLayout/CenterLayout';
import pageProps from '@/layout/pageProps';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import moment from 'moment';
import styles from '@/styles/pages/center/common.module.scss';

function LegalCenterPage() {
  const router = useRouter();
  const { t, i18n } = useTranslation('pages', { keyPrefix: router.pathname.split('/').slice(1).join('.') });

  return (
    <MainLayout
      headProps={{
        title: t('meta.title'),
        keyword: t('meta.keyword'),
        canonical: `https://www.bitop.com${i18n.language === 'en' ? '/en' : ''}/privacyPolicy`,
      }}
    >
      <CenterLayout>
        <div className={styles.pageContainer}>
          <article className={styles.article}>
            <h3>{t('header')}</h3>
            <div className={styles.date}>
              {
                i18n.language === 'en' ? moment(t('date')).format('[Published on] MMM Do, YYYY')
                  : moment(t('date')).format('YYYY年MM月DD日[发布]')
              }
            </div>

            <h4>{t('privacy')}</h4>
            <p>{t('privacyContent.0')}</p>
            <p>{t('privacyContent.1')}</p>

            <h4>{t('term.0.title')}</h4>
            <p>{t('term.0.Content.0')}</p>
            <p>{t('term.0.Content.1')}</p>
            <p>{t('term.0.Content.2')}</p>
            <p>{t('term.0.agreement.0')}</p>
            <p className={styles.blanked}>{t('term.0.agreement.1')}</p>
            <p className={styles.blanked}>{t('term.0.agreement.2')}</p>
            <p className={styles.blanked}>{t('term.0.agreement.3')}</p>

            <h4>{t('term.1.title')}</h4>
            <p>{t('term.1.Content.0')}</p>
            <p>{t('term.1.Content.1')}</p>

            <h4>{t('term.2.title')}</h4>
            <p>{t('term.2.describe')}</p>
            <p>{t('term.2.Content.0')}</p>
            <p>{t('term.2.Content.1')}</p>
            <p>{t('term.2.Content.2')}</p>
            <p>{t('term.2.Content.3')}</p>
            <p>{t('term.2.Content.4')}</p>
            <p>{t('term.2.Content.5')}</p>

            <h4>{t('term.3.title')}</h4>
            <p>{t('term.3.Content')}</p>

            <h4>{t('term.4.title')}</h4>
            <p>{t('term.4.Content.0')}</p>
            <p>{t('term.4.Content.1')}</p>

            <h4>{t('term.5.title')}</h4>
            <p>{t('term.5.Content.0')}</p>
            <p>{t('term.5.Content.1')}</p>

            <h4>{t('term.6.title')}</h4>
            <p>{t('term.6.Content.0.0')}</p>
            <p className={styles.blanked}>{t('term.6.Content.0.1')}</p>
            <p className={styles.blanked}>{t('term.6.Content.0.2')}</p>
            <p className={styles.blanked}>{t('term.6.Content.0.3')}</p>
            <p className={styles.blanked}>{t('term.6.Content.0.4')}</p>
            <p className={styles.blanked}>{t('term.6.Content.0.5')}</p>
            <p>{t('term.6.Content.1')}</p>
            <p>{t('term.6.Content.2')}</p>

            <h4>{t('term.7.title')}</h4>
            <p>{t('term.7.Content.0.0')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.1')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.2')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.3')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.4')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.5')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.6')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.7')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.8')}</p>
            <p className={styles.blanked}>{t('term.7.Content.0.9')}</p>
            <span>{t('term.7.describe')}</span>
            <p>{t('term.7.Content.1.0')}</p>
            <p className={styles.blanked}>{t('term.7.Content.1.1')}</p>
            <p className={styles.blanked}>{t('term.7.Content.1.2')}</p>
            <p className={styles.blanked}>{t('term.7.Content.1.3')}</p>
            <p className={styles.blanked}>{t('term.7.Content.1.4')}</p>
            <p className={styles.blanked}>{t('term.7.Content.1.5')}</p>
            <p>{t('term.7.Content.2')}</p>
            <p>{t('term.7.Content.3')}</p>
            <p>{t('term.7.Content.4')}</p>
            <p>{t('term.7.Content.5')}</p>
            <p>{t('term.7.Content.6')}</p>
            <p>{t('term.7.Content.7')}</p>
          </article>
        </div>
      </CenterLayout>
    </MainLayout>
  );
}

export async function getStaticProps(props) {
  const defaultProps = await pageProps(props);
  return { props: defaultProps };
}

export default LegalCenterPage;
